import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAbrKarteListStatus: 'idle',
    loadAbrKarteListError: undefined as any,
    loadAbrKarteListLastArgs: undefined as any,
    loadAbrKarteStatus: 'idle',
    loadAbrKarteError: undefined as any,
    saveAbrKarteStatus: 'idle',
    saveAbrKarteError: undefined as any,
    deleteAbrKarteStatus: 'idle',
    deleteAbrKarteError: undefined as any,
    BkIni_AbrKarteDruckFreigabeStatusStatus: 'idle',
    BkIni_AbrKarteDruckFreigabeStatusError: undefined as any,
    BkIni_AbrKarteBuchenFreigabeStatusStatus: 'idle',
    BkIni_AbrKarteBuchenFreigabeStatusError: undefined as any,
    setDruckfreigebeStatus: 'idle',
    setDruckfreigebeError: undefined as any,
    resetDruckfreigebeStatus: 'idle',
    resetDruckfreigebeError: undefined as any,

    abrKarteList: [] as any[],
    bkIni_AbrKarteBuchenFreigabeStatus: undefined as any,
    bkIni_AbrKarteDruckFreigabeStatus: undefined as any,
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAbrKarteList = createAsyncThunk('abrKarteSlice/loadAbrKarteList', async ({ globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().abrKarteSlice.loadAbrKarteListLastArgs
    if (_.isEqual(lastArgs, { globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/abrkarte/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAbrKarteListStatus } = getState().abrKarteSlice
        return loadAbrKarteListStatus !== 'pending'
    }
})

export const loadAbrKarte = createAsyncThunk('abrKarteSlice/loadAbrKarte', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/abrkarte/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAbrKarteStatus } = getState().abrKarteSlice
        return loadAbrKarteStatus !== 'pending'
    }
})

export const saveAbrKarte = createAsyncThunk('abrKarteSlice/saveAbrKarte', async ({ abrKarte }: any, { rejectWithValue }: any) => {
    let promises = []
    if (abrKarte?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/abrkarte/${ abrKarte?.HDR_ID }/`,
            prepareData(abrKarte),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/abrkarte/`,
            prepareData(abrKarte),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAbrKarteStatus } = getState().abrKarteSlice
        return saveAbrKarteStatus !== 'pending'
    }
})

export const deleteAbrKarte = createAsyncThunk('abrKarteSlice/deleteAbrKarte', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/abrkarte/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAbrKarteStatus } = getState().abrKarteSlice
        return deleteAbrKarteStatus !== 'pending'
    }
})

export const BkIni_AbrKarteDruckFreigabeStatus = createAsyncThunk('abrKarteSlice/BkIni_AbrKarteDruckFreigabeStatus', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BkIni_AbrKarteDruckFreigabeStatus/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BkIni_AbrKarteDruckFreigabeStatusStatus } = getState().abrKarteSlice
        return BkIni_AbrKarteDruckFreigabeStatusStatus !== 'pending'
    }
})

export const BkIni_AbrKarteBuchenFreigabeStatus = createAsyncThunk('abrKarteSlice/BkIni_AbrKarteBuchenFreigabeStatus', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BkIni_AbrKarteBuchenFreigabeStatus/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { BkIni_AbrKarteBuchenFreigabeStatusStatus } = getState().abrKarteSlice
        return BkIni_AbrKarteBuchenFreigabeStatusStatus !== 'pending'
    }
})

export const setDruckfreigebe = createAsyncThunk('abrKarteSlice/setDruckfreigebe', async ({ abrKarte, auth }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/abrkarte/${abrKarte.HDR_ID}/`,
        prepareData({...abrKarte, "DRUCKFREIGABE": 1}),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { setDruckfreigebeStatus } = getState().abrKarteSlice
        return setDruckfreigebeStatus !== 'pending'
    }
})

export const resetDruckfreigebe = createAsyncThunk('abrKarteSlice/resetDruckfreigebe', async ({ abrKarte }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/abrkarte/${abrKarte.HDR_ID}/`,
        prepareData({...abrKarte, "DRUCKFREIGABE": 0 }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { resetDruckfreigebeStatus } = getState().abrKarteSlice
        return resetDruckfreigebeStatus !== 'pending'
    }
})

const AbrKarteSlice = createSlice({
    name: 'abrKarteSlice',
    initialState,
    reducers: {
        resetloadAbrKarteListError: (state) => {
            state.loadAbrKarteListError = undefined
        },
        resetloadAbrKarte: (state) => {
            state.formItem = undefined
            state.loadAbrKarteError = undefined
        },
        resetloadAbrKarteError: (state) => {
            state.loadAbrKarteError = undefined
        },
        resetsaveAbrKarte: (state) => {
            state.formItem = undefined
            state.saveAbrKarteError = undefined
        },
        resetsaveAbrKarteError: (state) => {
            state.saveAbrKarteError = undefined
        },
        resetdeleteAbrKarteError: (state) => {
            state.deleteAbrKarteError = undefined
        },
        resetBkIni_AbrKarteDruckFreigabeStatus: (state) => {
            state.bkIni_AbrKarteDruckFreigabeStatus = undefined
            state.BkIni_AbrKarteDruckFreigabeStatusError = undefined
        },
        resetBkIni_AbrKarteDruckFreigabeStatusError: (state) => {
            state.BkIni_AbrKarteDruckFreigabeStatusError = undefined
        },
        resetBkIni_AbrKarteBuchenFreigabeStatus: (state) => {
            state.bkIni_AbrKarteBuchenFreigabeStatus = undefined
            state.BkIni_AbrKarteBuchenFreigabeStatusError = undefined
        },
        resetBkIni_AbrKarteBuchenFreigabeStatusError: (state) => {
            state.BkIni_AbrKarteBuchenFreigabeStatusError = undefined
        },
        resetsetDruckfreigebe: (state) => {
            state.formItem = undefined
            state.setDruckfreigebeError = undefined
        },
        resetsetDruckfreigebeError: (state) => {
            state.setDruckfreigebeError = undefined
        },
        resetresetDruckfreigebe: (state) => {
            state.formItem = undefined
            state.resetDruckfreigebeError = undefined
        },
        resetresetDruckfreigebeError: (state) => {
            state.resetDruckfreigebeError = undefined
        },
        removeFromAbrKarteListById: (state, action) => {
            state.abrKarteList = state.abrKarteList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAbrKarteListByIds: (state, action) => {
            state.abrKarteList = state.abrKarteList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.abrKarteList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAbrKarteListStatus = 'preloaded'
            state.loadAbrKarteListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.abrKarteList = []
            state.loadAbrKarteListStatus = 'idle'
            state.loadAbrKarteListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAbrKarteList.pending, (state) => {
            state.loadAbrKarteListStatus = 'pending'
            state.loadAbrKarteListError = undefined
        })
        builder.addCase(loadAbrKarteList.fulfilled, (state, action) => {
            state.loadAbrKarteListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAbrKarteListLastArgs = action.payload.args

            {
                state.abrKarteList = action.payload.data

            }
        })
        builder.addCase(loadAbrKarteList.rejected, (state, action) => {
            state.loadAbrKarteListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAbrKarteListError = action.error.message
            } else {
                state.loadAbrKarteListError = action.payload
            }
        })

        builder.addCase(loadAbrKarte.pending, (state) => {
            state.loadAbrKarteStatus = 'pending'
            state.loadAbrKarteError = undefined
        })
        builder.addCase(loadAbrKarte.fulfilled, (state, action) => {
            state.loadAbrKarteStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.abrKarteList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.abrKarteList.push(newItem) }
                else { state.abrKarteList[i] = { ...state.abrKarteList[i], ...newItem } }
            }
        })
        builder.addCase(loadAbrKarte.rejected, (state, action) => {
            state.loadAbrKarteStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAbrKarteError = action.error.message
            } else {
                state.loadAbrKarteError = action.payload
            }
        })

        builder.addCase(saveAbrKarte.pending, (state) => {
            state.saveAbrKarteStatus = 'pending'
            state.saveAbrKarteError = undefined
        })
        builder.addCase(saveAbrKarte.fulfilled, (state, action) => {
            state.saveAbrKarteStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.abrKarteList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.abrKarteList.push(newItem) }
                else { state.abrKarteList[i] = { ...state.abrKarteList[i], ...newItem } }
            }
        })
        builder.addCase(saveAbrKarte.rejected, (state, action) => {
            state.saveAbrKarteStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAbrKarteError = action.error.message
            } else {
                state.saveAbrKarteError = action.payload
            }
        })

        builder.addCase(deleteAbrKarte.pending, (state) => {
            state.deleteAbrKarteStatus = 'pending'
            state.deleteAbrKarteError = undefined
        })
        builder.addCase(deleteAbrKarte.fulfilled, (state, action) => {
            state.deleteAbrKarteStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.abrKarteList = state.abrKarteList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.abrKarteList = state.abrKarteList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAbrKarte.rejected, (state, action) => {
            state.deleteAbrKarteStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAbrKarteError = action.error.message
            } else {
                state.deleteAbrKarteError = action.payload
            }
        })

        builder.addCase(BkIni_AbrKarteDruckFreigabeStatus.pending, (state) => {
            state.BkIni_AbrKarteDruckFreigabeStatusStatus = 'pending'
            state.BkIni_AbrKarteDruckFreigabeStatusError = undefined
        })
        builder.addCase(BkIni_AbrKarteDruckFreigabeStatus.fulfilled, (state, action) => {
            state.BkIni_AbrKarteDruckFreigabeStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.bkIni_AbrKarteDruckFreigabeStatus = newItem
            }
        })
        builder.addCase(BkIni_AbrKarteDruckFreigabeStatus.rejected, (state, action) => {
            state.BkIni_AbrKarteDruckFreigabeStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BkIni_AbrKarteDruckFreigabeStatusError = action.error.message
            } else {
                state.BkIni_AbrKarteDruckFreigabeStatusError = action.payload
            }
        })

        builder.addCase(BkIni_AbrKarteBuchenFreigabeStatus.pending, (state) => {
            state.BkIni_AbrKarteBuchenFreigabeStatusStatus = 'pending'
            state.BkIni_AbrKarteBuchenFreigabeStatusError = undefined
        })
        builder.addCase(BkIni_AbrKarteBuchenFreigabeStatus.fulfilled, (state, action) => {
            state.BkIni_AbrKarteBuchenFreigabeStatusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.bkIni_AbrKarteBuchenFreigabeStatus = newItem
            }
        })
        builder.addCase(BkIni_AbrKarteBuchenFreigabeStatus.rejected, (state, action) => {
            state.BkIni_AbrKarteBuchenFreigabeStatusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.BkIni_AbrKarteBuchenFreigabeStatusError = action.error.message
            } else {
                state.BkIni_AbrKarteBuchenFreigabeStatusError = action.payload
            }
        })

        builder.addCase(setDruckfreigebe.pending, (state) => {
            state.setDruckfreigebeStatus = 'pending'
            state.setDruckfreigebeError = undefined
        })
        builder.addCase(setDruckfreigebe.fulfilled, (state, action) => {
            state.setDruckfreigebeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.abrKarteList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.abrKarteList.push(newItem) }
                else { state.abrKarteList[i] = { ...state.abrKarteList[i], ...newItem } }
            }
        })
        builder.addCase(setDruckfreigebe.rejected, (state, action) => {
            state.setDruckfreigebeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.setDruckfreigebeError = action.error.message
            } else {
                state.setDruckfreigebeError = action.payload
            }
        })

        builder.addCase(resetDruckfreigebe.pending, (state) => {
            state.resetDruckfreigebeStatus = 'pending'
            state.resetDruckfreigebeError = undefined
        })
        builder.addCase(resetDruckfreigebe.fulfilled, (state, action) => {
            state.resetDruckfreigebeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.abrKarteList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.abrKarteList.push(newItem) }
                else { state.abrKarteList[i] = { ...state.abrKarteList[i], ...newItem } }
            }
        })
        builder.addCase(resetDruckfreigebe.rejected, (state, action) => {
            state.resetDruckfreigebeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.resetDruckfreigebeError = action.error.message
            } else {
                state.resetDruckfreigebeError = action.payload
            }
        })

    }
})

export const {
    resetloadAbrKarteListError,
    resetloadAbrKarte,
    resetloadAbrKarteError,
    resetsaveAbrKarte,
    resetsaveAbrKarteError,
    resetdeleteAbrKarteError,
    resetBkIni_AbrKarteDruckFreigabeStatus,
    resetBkIni_AbrKarteDruckFreigabeStatusError,
    resetBkIni_AbrKarteBuchenFreigabeStatus,
    resetBkIni_AbrKarteBuchenFreigabeStatusError,
    resetsetDruckfreigebe,
    resetsetDruckfreigebeError,
    resetresetDruckfreigebe,
    resetresetDruckfreigebeError,
    removeFromAbrKarteListById,
    removeFromAbrKarteListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AbrKarteSlice.actions
export default AbrKarteSlice.reducer
